import React from 'react'

const CashRuppeeIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 500 500"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <linearGradient
                        id="a"
                        x1="220.704"
                        x2="220.704"
                        y1={44}
                        y2="399.66"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset={0} stopColor="#127838" />
                        <stop offset={1} stopColor="#043717" />
                    </linearGradient>
                    <linearGradient
                        id="b"
                        x1="228.732"
                        x2="228.732"
                        y1="46.469"
                        y2="381.548"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset={0} stopColor="#2cb461" />
                        <stop offset={1} stopColor="#0d6e31" />
                    </linearGradient>
                    <path
                        fill="#5ad18860"
                        d="m76.673 320.61 102.263 128.696c4.453 5.604 11.982 7.799 18.68 5.277 129.304-48.698 221.087-144.281 271.503-217.085 5.466-7.894 2.854-18.687-5.451-23.504l-155.01-89.911c-4.631-2.686-10.542-1.283-13.576 3.126-50.297 73.097-125.384 137.528-214.477 177.654-6.099 2.746-8.093 10.51-3.932 15.747z"
                        opacity={1}
                        data-original="#5ad18860"
                    />
                    <path
                        fill="url(#a)"
                        stroke="#fff"
                        strokeWidth="9.189"
                        d="m36.354 290.974 128.629 106.144c5.914 4.88 14.345 5.527 20.898 1.374 120.188-76.169 191.516-192.528 225.601-275.497 3.971-9.665-1.307-20.394-11.052-23.582L226.762 42.6c-7.425-2.429-15.354 1.38-18.302 8.487-33.68 81.185-93.204 159.145-171.326 216.418-7.739 5.674-8.318 17.25-.78 23.47z"
                        opacity={1}
                        data-original="url(#a)"
                        className=""
                    />
                    <path
                        fill="url(#b)"
                        d="M212.706 52.852c-34 81.956-94.051 160.591-172.853 218.363-5.395 3.955-5.732 11.963-.573 16.221l109.4 90.275c5.665 4.675 13.722 5.157 19.785 1.011 91.778-62.765 167.161-157.5 214.485-264.954 3.16-7.175-.649-15.447-8.101-17.885L225.336 46.971c-5.088-1.664-10.579.937-12.63 5.88z"
                        opacity={1}
                        data-original="url(#b)"
                        className=""
                    />
                    <g fill="#09522a">
                        <path
                            d="M98 239c30.4 30.4 12.167 65-.5 79l-40.064-33.317c-3.86-3.209-3.845-9.139.031-12.328zM348.5 164.999c-35.073-24.864-35.136-58.071-25-73.999l46.959 17.616c4.635 1.739 6.595 7.227 4.108 11.508zM121.498 337.999c24.473-35.347 72.116-13.225 88.155-3.267L167 370.394a8 8 0 0 1-10.546-.249zM279.496 75.998C257.5 109.5 217.609 112.68 198.999 109.5l17.575-48.667a8 8 0 0 1 10.36-4.763zM264.419 223.828l-10.222 9.889-55.438-33.544 10.281-9.854zm-67.809 45.981-7.736-49.466 6.388-10.69 13.699 8.289c2.927 1.771 5.712 2.63 8.357 2.577 2.644-.053 5.06-.83 7.248-2.331 2.189-1.502 4.05-3.521 5.585-6.058 1.559-2.576 2.511-5.119 2.857-7.629.408-2.525-.002-4.932-1.229-7.221-1.165-2.304-3.347-4.425-6.548-6.361l-15.22-9.21 12.591-12.614 11.591 7.013c7.025 4.251 12.261 8.859 15.708 13.823 3.486 4.989 5.203 10.213 5.152 15.673.011 5.445-1.684 10.978-5.085 16.598-2.999 4.956-6.381 8.827-10.146 11.614-3.727 2.81-7.953 4.465-12.68 4.963-4.665.484-9.97-.221-15.916-2.112l6.58 44.768-.531.878zm80.903-67.489-10.258 9.948-46.13-27.912 10.258-9.948z"
                            fill="#09522a"
                            opacity={1}
                            data-original="#09522a"
                            className=""
                        />
                    </g>
                    <path
                        fill="#f8ffcb"
                        d="m262.497 214.047-10.222 9.889-55.438-33.545 10.281-9.853zm-67.809 45.981-7.736-49.467 6.388-10.689 13.699 8.288c2.927 1.771 5.712 2.631 8.357 2.578 2.644-.053 5.06-.83 7.249-2.332 2.188-1.501 4.049-3.521 5.584-6.057 1.559-2.576 2.511-5.119 2.857-7.629.408-2.525-.001-4.932-1.229-7.221-1.165-2.304-3.347-4.425-6.547-6.361l-15.221-9.21 12.591-12.614 11.591 7.013c7.025 4.251 12.261 8.858 15.708 13.823 3.486 4.989 5.203 10.213 5.152 15.673.011 5.445-1.684 10.977-5.084 16.597-3 4.957-6.382 8.828-10.147 11.615-3.727 2.81-7.953 4.464-12.68 4.963-4.664.483-9.97-.221-15.916-2.113l6.58 44.768-.531.878zm80.903-67.489-10.258 9.948-46.13-27.912 10.258-9.948z"
                        opacity={1}
                        data-original="#f8ffcb"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default CashRuppeeIcon